/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useCallback, useMemo, useState } from 'react';
import { useEffect } from 'react';
import {
    Button, Modal, Row, Col, FormGroup, Label, Input, Container
} from "reactstrap";
import api from "../../../../services/api";
import { Mode } from '../../../../utils';
import { formatDate, momentToDateOnly } from '../../../../utils/index';
import { DatePicker } from '../../../date-pickers';

export default function ExportAccommodationFlightDialog(props) {
    const {
        onClose,
        itemInEditRef: sourceRef,
        setItemInEdit: setSource,
        //inputStartDateRef,
        //inputEndDateRef,
        //setInputStartDate,
        //setInputEndDate,
        action
    } = props;


    const [itemInEdit, setItemInEdit] = useState(sourceRef?.current);

    useEffect(() => {
        setSource(itemInEdit);
    }, [itemInEdit]);



    // Refs
    const handleDateChanged = useCallback((name, value) => {
        // console.log({name, value});
        setItemInEdit({
            ...itemInEdit,
            [name]: value ? momentToDateOnly(value) : null
        });
    }, [itemInEdit]);


    return (
        <Modal
            isOpen={true}
        >
            <div
                className="modal-header"
            >
                <Container fluid>
                    <Row>
                        <Col lg={9}>
                            <h5
                                className="modal-title"
                            >
                                Export Accommodation & Flights
                            </h5>
                        </Col>
                        <Col lg={3}>
                            <button
                                aria-label="Close"
                                className="close"
                                onClick={onClose}
                                type="button"
                            >
                                <span aria-hidden={true}><i className="fas fa-times-circle" /></span>
                            </button>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <h6 className="modal-title">

                            </h6>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="modal-body">
                <Row>
                    <Col lg={12} xs={12}>
                    Please click on the button below to download the Accommodation & Flights file.
                    </Col>

                </Row>
            </div>
            <div
                className="modal-footer"
            >
                <div className="w-100 h-100 d-flex flex-wrap justify-content-end align-items-center">
                    <Button
                        color="default"
                        onClick={() => action()}
                        type="button"
                    >
                        Download
                    </Button>
                    <Button
                        color="secondary"
                        onClick={onClose}
                        type="button"
                    >
                        Close
                    </Button>
                </div>
            </div>
        </Modal>
    )
}